import {
  LicenseTransactionTypes,
  OrganizationTypes,
  PlanType,
} from '@showbie-socrative/socrative-utils';

export interface AmplitudeData {
  public_id: string;
  is_licensed: boolean;
  user_version: string;
  signed_up_at: Date;
  institution_name: string;
  institution_type: string;
  district_name?: any;
  role: string;
  state: string;
  zip_code: string;
  app_language: string;
}

// TODO: Move to Socrative UTILS
export enum VerificationStatus {
  Unverified = 0,
  SoftVerify = 1,
  Verified = 2,
}

export interface AccountResponse {
  autoRenew: boolean;
  canAutoRenew: boolean;
  licenseKey: string;
  customerType: LicenseTransactionTypes | null;
  isBuyer: boolean;
  country: string;
  language: string;
  districtName?: any;
  email: string;
  verificationStatus: VerificationStatus;
  expiration?: any;
  firstName: string;
  lastName: string;
  mcUser: boolean;
  orgName: string;
  orgType: OrganizationTypes;
  role: string[];
  schoolId?: any;
  schoolName: string;
  city: string;
  state: string;
  zipCode: string;
  description: string;
  hmacToken: string;
  betaFlags: any;
  amplitudeData: AmplitudeData;
  publicId: string;
  blingId?: any;
  phoneNumber?: any;
  version: number;
  isPro: boolean;
  plan: PlanType;
}
